module.exports = __webpack_public_path__ + "img/y_160m.prt.63048a6e.jpg";